import React from 'react'
import { defaultProps } from './index'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const ApplicazioneCardSettings = (settingsProps) => {
  return (
    <>{!settingsProps.floating && <ImageToolbarSection defaultProps={defaultProps} initOpen />}</>
  )
}

export const ApplicazioneCardFloatingSettings = () =>
  React.createElement(ApplicazioneCardSettings, { floating: true })
